export type DateString = string;
export type DateTimeString = string;

export class IpDate {
  private readonly _date;

  constructor(date?: Date) {
    this._date = date || new Date();
  }

  get date(): Date {
    return this._date;
  }

  toDateTimeString(): DateTimeString {
    return this._date.toISOString();
  }

  toDateString(): DateString {
    return this.toDateTimeString().slice(0, 10);
  }

  sot(): IpDate {
    this._date.setUTCHours(0, 0, 0, 0);
    return this;
  }

  eot(): IpDate {
    this._date.setUTCHours(23, 59, 59, 999);
    return this;
  }

  addDays(days: number): IpDate {
    this._date.setDate(this._date.getDate() + days);
    return this;
  }

  isBefore(date: IpDate) {
    return this._date <= date.date;
  }

  isAfter(date: IpDate): boolean {
    return this._date >= date.date;
  }
}
